export default () => ({
  isApproved: true,
  credential: {},
  totalFail: false
})
